// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wizard{\n    padding-left:4px;\n}\n.wizard-step__square-icon{\n    color: #1e88e5;\n    position:absolute;\n    left:-0.5rem;\n    top:0.2rem;\n    padding:0.25rem;\n    background: white;\n    width:1rem !important;\n    height: 1rem;\n}\n\n.wizard-step__square-icon--first{\n    padding-top:0.5rem;\n    height:1.25rem;\n    top:-0.05rem;\n}\n", ""]);
// Exports
module.exports = exports;
